import { useState, useEffect } from 'react';
import classNames from 'classnames';
import styled from 'styled-components';
import { compose } from '../../utils/compose';
import { withStrictMode } from '../../utils/with-strict-mode';
import useIsMounted from '../../custom-hooks/useIsMounted';
import { device } from '../../../utils/styled-component-mixins';

const GenericCardStyled = styled.div`
  height: 100%;

  .generic-card-wrapper {
    height: 100%;
    position: relative;

    @media ${device.desktop} {
      height: 100%;

      .hover-in {
        .overflow-wrapper {
          right: 0;
        }
      }

      .hover-out {
        .overflow-wrapper {
          right: 7rem;
        }
      }
    }

    .featured-tag {
      z-index: 110;
    }

    a:not(.non-default-link, .dropdown-item) {
      text-decoration: none !important;
      color: var(--charcoal);
    }
  }

  .generic-card-content {
    background-color: var(--white);
    height: 100%;
    padding: 2.4rem 1.6rem;
    position: relative;
    z-index: 100;

    @media ${device.desktop} {
      padding: 4rem 4rem 3.2rem 4rem;
    }
  }

  .content-wrapper {
    color: var(--charcoal);
  }

  .overflow-wrapper {
    height: 3.4rem;

    .cta-wrapper {
      span:first-child {
        font-size: 1.4rem;
        font-weight: 700;
      }

      span:last-child {
        top: 50%;
      }
    }
  }

  .animation-wrapper {
    align-items: flex-start;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
    overflow: hidden;
  }

  h3 {
    @media ${device.desktop} {
      font-size: 2.2rem;
      line-height: 3.2rem;
    }
  }

  .overflow-wrapper {
    position: relative;
    margin-bottom: 25px;
    transition: all 0.3s ease-in-out !important;
  }

  .overflow-wrapper > .cta-wrapper {
    align-items: center;
    color: var(--cta-blue);
    display: flex;
    font-size: 1.4rem;
    font-weight: 700;
    line-height: 1.8rem;
    margin-top: 1rem;
    text-decoration: none;

    span:last-child {
      font-size: 3.2rem;
    }
    @media ${device.tablet} {
      transition: all 0.3s ease-in-out;

      span:first-child {
        transition: all 0.3s ease-in-out;
      }
    }
  }
`;

const GenericCard = (props) => {
  const { item } = props;
  const [hoverState, setHoverState] = useState(null);
  const isMounted = useIsMounted();

  useEffect(() => {
    setHoverState('hover-out');
  }, []);

  return (
    <GenericCardStyled
      onMouseEnter={() => setHoverState('hover-in')}
      onMouseLeave={() => setHoverState('hover-out')}
    >
      <div className="generic-card-wrapper">
        <a
          href={item.externalUrl ? item.externalUrl : item.url}
          target={item.externalUrl ? '_blank' : props.urlTarget}
          aria-label={`Read more about ${item.pageTitle}`}
        >
          {item.isFeatured && <div className="featured-tag">{item.featuredTagText}</div>}
          <div className="generic-card-content">
            <div className={classNames('animation-wrapper', hoverState, { mounted: isMounted })}>
              <div className="content-wrapper">
                <h3>{props.item.pageTitle}</h3>
                <p className="description">{props.item.description}</p>
              </div>
              <div className="overflow-wrapper">
                {item.readMoreText && (
                  <div className="cta-wrapper">
                    <span>{item.readMoreText}</span>
                    <span className="material-icons-round" aria-hidden="true">
                      chevron_right
                    </span>
                  </div>
                )}
              </div>
            </div>
          </div>
        </a>
      </div>
    </GenericCardStyled>
  );
};

GenericCard.defaultProps = {
  urlTarget: '_self'
};

export default compose(withStrictMode)(GenericCard);
